export interface MobileMoneyOption {
  provider: string
  numero: string
  titulaire?: string
  badgeClass: string
}

// Numéros Mobile Money officiels du CMP Lubumbashi.
export const MOBILE_MONEY_OPTIONS: MobileMoneyOption[] = [
  {
    provider: 'Airtel Money',
    numero: '097 090 39 40',
    badgeClass: 'bg-red-600',
  },
  {
    provider: 'Orange Money',
    numero: '089 89 27 266',
    badgeClass: 'bg-orange-500',
  },
  {
    provider: 'M-Pesa',
    numero: '08942',
    badgeClass: 'bg-green-600',
  },
]

// Coordonnées bancaires — pour les dons depuis l'étranger (diaspora).
export const COMPTE_BANCAIRE = {
  banque: 'Equity Bank',
  numero: '00018000160112928120032',
}
